class ProductConfigurator {
  constructor(sayduckAPI) {
    this.api = sayduckAPI;
    this.configuration = this.ModifyConfigurations(
      sayduckAPI.configurator.getConfigurations()
    );
    this.activeScreen =
      this.configuration.length > 0 ? this.configuration[0] : null;
    this.firstLevelWrapper = document.getElementById(
      "configurator__swatches__first-level"
    );
    this.secondLevelWrapper = document.getElementById(
      "configurator__swatches__second-level"
    );
    this.mainProduct = null;
    this.pageCurrency = "GBP";
   this.selectedElements = {
  surfaceColor: "56c2c730-a0cf-013f-c249-5a28208f9353",
      theme: "333123a0-368e-013f-e8fc-6a4000cd166d",
      themeSelection: "33382730-368e-013f-ec6b-6a4000cd166d",
      lineDesignAndColors: "33b981c0-368e-013f-1b17-6a4000cd166d",
      lineDesignAndColorsSelection: "33b9e730-368e-013f-fc68-6a4000cd166d",
      endToEndLines: "3489df10-368e-013f-6af2-6a4000cd166d",
      sideBars: "34831ba0-368e-013f-9711-6a4000cd166d",
      reversePoints: "3486f350-368e-013f-c466-6a4000cd166d",
      fontAndColour: "liformeFont",
fontColour: "babyBlue",
     text: "33f5a090-368e-013f-85ce-6a4000cd166d",
      textOptionSelection: "33f5f460-368e-013f-2952-6a4000cd166d",
      textSelection: "You",
};
    // Automatically select the only print group and its first combination.
    const lineGroup = this.configuration.find(
      (config) => config.name === "Line Design & Colours"
    )?.children?.[0];
    if (lineGroup) {
      this.selectedElements.lineDesignAndColors = lineGroup.uuid;
      this.selectedElements.lineDesignAndColorsSelection =
        lineGroup.children?.[0]?.uuid || "";
    }
    this.urlSearchParams = new URLSearchParams(window.location.search);
    this.blackListedWords = localStorage.getItem("blacklisted-words");
  }

  ModifyConfigurations(configurations) {
    // Remove ground plane
    const filteredConfigurations = configurations.filter(
      (config) => config.name !== "Ground Plane"
    );

    // Remove all themes except Mandalas
    const currentThemes = configurations.filter(
      (config) => config.name === "Theme Category"
    );
    const currentThemesIndex = configurations.indexOf(currentThemes[0]);

    const themeMandala = currentThemes[0].children.filter(
      (theme) => theme.name === "Mandalas"
    );

    const validMandalas = themeMandala[0].children.filter(
      (validManadala) =>
        validManadala.name === "Tropical"
    );

    const mandalas = {
      ...themeMandala[0],
      children: [...validMandalas],
    };

    const themes = {
      ...currentThemes[0],
      children: [
        {
          ...mandalas,
        },
      ],
    };

    filteredConfigurations[currentThemesIndex] = themes;

    // Add Mantras
    const textObject = configurations.filter(
      (config) => config.name === "Text"
    );
    const textIndex = configurations.indexOf(textObject[0]);
    const currentMantrasObject = textObject[0].children.filter(
      (child) => child.name === "Mantra & Affirmations"
    );
    const currentMantrasIndex = textObject[0].children.indexOf(
      currentMantrasObject[0]
    );
    const mantras = [
      {
        id: "liveForMore",
        isConfiguration: false,
        name: "Live For More",
        uuid: "liveForMore",
      },
      {
        id: "liveInGoodForm",
        isConfiguration: false,
        name: "Live Life In Good Form",
        uuid: "liveInGoodForm",
      },
      {
        id: "iAmGrateful",
        isConfiguration: false,
        name: "I am grateful",
        uuid: "iAmGrateful",
      },
      {
        id: "iOwnMyPower",
        isConfiguration: false,
        name: "I own my power",
        uuid: "iOwnMyPower",
      },
    ];
    const newMantrasObject = {
      ...currentMantrasObject[0],
      children: mantras,
    };

    filteredConfigurations[textIndex].children[currentMantrasIndex] =
      newMantrasObject;

    // Create Font & Color
    const fontAndColor = {
      children: [
        {
          id: "liformeFont",
          isConfiguration: false,
          name: "Liforme",
          uuid: "liformeFont",
        },
        {
          id: "simpleFont",
          isConfiguration: false,
          name: "Simple",
          uuid: "simpleFont",
        },
        {
          id: "roundedFont",
          isConfiguration: false,
          name: "Rounded",
          uuid: "roundedFont",
        },
        {
          id: "handwrittenFont",
          isConfiguration: false,
          name: "Handwritten",
          uuid: "handwrittenFont",
        },
       {
  id: "babyBlue",
  isConfiguration: false,
  name: "Baby Blue",
  uuid: "babyBlue",
  isIndependentSwatch: true,
},
{
  id: "lime",
  isConfiguration: false,
  name: "Lime",
  uuid: "lime",
  isIndependentSwatch: true,
},
{
  id: "pastelOrange",
  isConfiguration: false,
  name: "Pastel Orange",
  uuid: "pastelOrange",
  isIndependentSwatch: true,
},
{
  id: "vanilla",
  isConfiguration: false,
  name: "Vanilla",
  uuid: "vanilla",
  isIndependentSwatch: true,
},
{
  id: "citrus",
  isConfiguration: false,
  name: "Citrus",
  uuid: "citrus",
  isIndependentSwatch: true,
},
{
  id: "lavender",
  isConfiguration: false,
  name: "Lavender",
  uuid: "lavender",
  isIndependentSwatch: true,
},
{
  id: "peony",
  isConfiguration: false,
  name: "Peony",
  uuid: "peony",
  isIndependentSwatch: true,
},
      ],
      id: "fontAndColour",
            uuid: "fontAndColour",
      name: "Font and Colour",
      label: "Font & Colour",
      isConfiguration: true,
    };

    // Create Summary Page
    const summaryPage = {
      id: "summary",
      uuid: "summary",
      name: "Summary",
    };

    // Keep only the 3 Color print group from Sayduck.
    const newConfigurations = [
      ...filteredConfigurations.filter((config) =>
        ["Surface Color", "Line Design & Colours", "45 Degree Lines",
         "Reverse Point", "End to End points", "Text"].includes(config.name)
      ).map((config) => {
        if (config.name !== "Line Design & Colours") return config;
        return {
          ...config,
          children: config.children.filter((child) => child.name === "3 Color")
        };
      }),
      fontAndColor,
      summaryPage,
    ];
    return newConfigurations;
  }

  InitializeConfigurator() {
    this.BuildLoadingModal();
    const selectedElementsArray = Object.keys(this.selectedElements);
    const mapPropertyToParent = (key) => {
      switch (key) {
        case "surfaceColor":
          return {
            parentName: "Surface Color",
            level: 1,
          };
        case "sideBars":
          return {
            parentName: "45 Degree Lines",
            level: 1,
          };
        case "reversePoints":
          return {
            parentName: "Reverse Point",
            level: 1,
          };
        case "endToEndLines":
          return {
            parentName: "End to End points",
            level: 1,
          };
        case "fontAndColour":
          return {
            parentName: "Font and Colour",
            level: 1,
          };
        case "textOptionSelection":
          return {
            parentName: "Text",
            level: 2,
          };
        case "themeSelection":
          return {
            parentName: "Theme Category",
            level: 2,
          };
        case "lineDesignAndColorsSelection":
          return {
            parentName: "Line Design & Colours",
            level: 2,
          };
      }
    };

    const replaceSelectedItems = () => {
      selectedElementsArray.forEach((key) => {
        const paramExistsInURL = this.urlSearchParams.has(key);

        if (paramExistsInURL) {
          const value = this.urlSearchParams.get(key);

          const newProperties = {
            ...this.selectedElements,
            [key]: value,
          };

          this.selectedElements = newProperties;
        }
      });
    };

    const preselectItems = () => {
      selectedElementsArray.forEach((key) => {
        const parentInformation = mapPropertyToParent(key);
        if (parentInformation) {
          const { parentName, level } = parentInformation;
          const parentObject = this.configuration.filter(
            (config) => config.name === parentName
          );
          if (parentObject.length > 0) {
            const currentParent = parentObject[0];
            const currentChildrenValue = this.selectedElements[key];

            let selectedParent = null;
            let selectedChildren = null;
            if (level === 1) {
              const childrenObject = currentParent.children.filter(
                (child) => child.uuid === currentChildrenValue
              );

              if (childrenObject.length > 0) {
                const currentChildren = childrenObject[0];
                selectedParent = currentParent;
                selectedChildren = currentChildren;
              }
            } else {
              currentParent.children.forEach((child) => {
                const filtered = child.children.filter(
                  (filter) => filter.uuid === currentChildrenValue
                );
                if (filtered.length === 1) {
                  const currentFilteredElement = filtered[0];
                  selectedParent = currentParent;
                  selectedChildren = currentFilteredElement;
                }
              });
            }

            // Check type of elements
            switch (key) {
              case "surfaceColor":
              case "themeSelection":
              case "lineDesignAndColorsSelection":
              case "endToEndLines":
              case "sideBars":
              case "reversePoints":

                if (selectedParent && selectedChildren) {
                  this.UpdateVisualizer(selectedParent, selectedChildren);
                }
                break;

              // TODO: Preload font and text
              // case "fontAndColour":
              //   const fontFamily = this.GetFontFamily(selectedChildren.uuid);
              //   if (fontFamily) {
              //     this.UpdateTextNodeAttributes({ font: fontFamily });
              //   }
              //   break;

              // case "textOptionSelection":
              //   if (selectedParent && selectedChildren) {
              //     this.UpdateVisualizer(selectedParent, selectedChildren);
              //   }
              //   const textValue = this.selectedElements.textSelection;
              //   const modifiedText = this.GetModifiedText(textValue);
              //   this.UpdateTextNode(modifiedText);
              //   this.UpdateTextNodeAttributes();

              //   break;
            }
          }
        }
      });
    };

    const getMainProduct = async () => {
      const productConfiguratorDOM = document.getElementById(
        "3d-product-configurator"
      );
      const productConfiguratorDataset = productConfiguratorDOM.dataset;
      const { productHandle } = productConfiguratorDataset;

      if (productHandle) {
        const yogaMatRequest = await fetch(
  `${window.Shopify.routes.root}products/${productHandle}.js`
);
        const yogaMat = await yogaMatRequest.json();
        console.log("Yoga mat!!!!");
        console.log(yogaMat);
        this.mainProduct = yogaMat;
      } else {
        // TODO: Throw an error
        console.log("error yoga mat!");
      }
    };

    const getPageCurrency = () => {
      const currency = window.Shopify.currency.active;
      this.pageCurrency = currency;
    };
    

    setTimeout(async () => {
      replaceSelectedItems();
      preselectItems();

      await getMainProduct();
      getPageCurrency();

      this.BuildActiveScreen();
      this.UpdateLivePrice();
    }, 200);

    setTimeout(async () => {
      await this.ChangeCameraPosition("Surface Color");
    }, 1000);
  }

  GetInnerConfiguration(parentName, level, key) {
    const parentObject = this.configuration.filter(
      (config) => config.name === parentName
    );

    if (parentObject.length === 1) {
      const currentParent = parentObject[0];
      const currentChildrenValue = this.selectedElements[key];

      let selectedParent = null;
      let selectedChildren = null;

      if (level === 1) {
        const childrenObject = currentParent.children.filter(
          (child) => child.uuid === currentChildrenValue
        );

        if (childrenObject.length > 0) {
          selectedParent = currentParent;
          selectedChildren = childrenObject[0];
        }
      } else {
        currentParent.children.forEach((child) => {
          const filtered = child.children.filter(
            (item) => item.uuid === currentChildrenValue
          );

          if (filtered.length === 1) {
            selectedParent = currentParent;
            selectedChildren = filtered[0];
          }
        });
      }

      return {
        selectedParent,
        selectedChildren,
      };
    }

    return null;
  }

  SetQueryParameters(property, value) {
    this.urlSearchParams.set(property, value);

    const allParams = this.urlSearchParams.toString();

    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${allParams}`
    );
  }

  async ChangeCameraPosition(step) {
    const cameraAngles = await this.api.scene.getCameraUuids();

    switch (step) {
      case "Surface Color": {
        this.api.scene.setActiveCamera(cameraAngles[0]);
        break;
      }

      case "Summary":
      case "45 Degree Lines":
      case "Reverse Point":
      case "Line Design & Colours": {
        this.api.scene.setActiveCamera(cameraAngles[2]);
        break;
      }

      case "Theme Category":
      case "End to End points": {
        this.api.scene.setActiveCamera(cameraAngles[1]);
        break;
      }

      case "Text":
      case "Font and Colour": {
        this.api.scene.setActiveCamera(cameraAngles[4]);
        break;
      }
    }
  }

  async BuildLoadingModal() {
    const modalData = window.configuratorModal;
    const modalDiv = document.getElementById("configurator-modal");

    if (modalData.enabled === "true") {
      let html = `<div class="modal-wrapper">`;

      html += `
        <button class="modal-close js-modal-close">
          <span>+</span>
        </button>
      `;

      if (modalData.title !== "") {
        html += `<p class="modal-title">${modalData.title}</p>`;
      }

      if (modalData.body !== "") {
        html += `<p class="modal-body">${modalData.body}</p>`;
      }

      if (modalData.continue !== "" || modalData.urlText !== "") {
        html += `<div class="modal-separator"></div>`;
      }

      html += `<div class="modal-buttons">`;

      if (modalData.continue !== "") {
        html += `
          <span class="modal-continue button button--tertiary js-modal-close">
            ${modalData.continue}
          </span>
        `;
      }

      if (modalData.urlText !== "") {
        html += `
          <a class="modal-url button button--tertiary button-second"
             href="${modalData.url}">
            <span class="modal-url-text">${modalData.urlText}</span>
          </a>
        `;
      }

      html += `</div></div>`;

      modalDiv.innerHTML = html;

      Array.from(
        document.getElementsByClassName("js-modal-close")
      ).forEach((button) => {
        button.addEventListener("click", () => {
          modalDiv.classList.add("hidden");
        });
      });
    }
  }

  async BuildActiveScreen() {
    const activeScreenPosition = this.configuration.indexOf(
      this.activeScreen
    );

    const isLastScreen =
      activeScreenPosition === this.configuration.length - 1;

    const { isConfiguration, children, name, label } = this.activeScreen;

    this.UpdateUIElements(label);
    this.UpdateLivePrice();

    await this.ChangeCameraPosition(name);

    if (isLastScreen) {
      await this.BuildSummaryPage();
      return;
    }

    if (isConfiguration) {
      this.BuildConfigurationLevel(children, name, 1);
      return;
    }
  }

  UpdateLivePrice() {
    const selectedVariant = this.GetSelectedVariant();

    if (!selectedVariant) return;

    const formattedPrice = Shopify.formatMoney(
      selectedVariant.price,
      theme.moneyFormat
    );

    const priceElement = document.querySelector(
      "#configurator-live-price strong"
    );

    if (priceElement) {
      priceElement.innerHTML = formattedPrice;
    }
  }

  async BuildSummaryPage() {
    console.log("FINAL DESIGN: Function started");

    const headingDOM = document.getElementById(
      "product-config__current-heading"
    );

    headingDOM.innerText = "Final Design";

    this.firstLevelWrapper.innerHTML = "";
    this.secondLevelWrapper.innerHTML = "";

    const selectedVariant = this.GetSelectedVariant();

    if (!selectedVariant) {
      this.firstLevelWrapper.innerHTML =
        "<p>This base colour is currently unavailable. Please select another colour.</p>";
      return;
    }

    const lineProperties = await this.CreateLineItems();
    const { title } = this.mainProduct;

    const formattedPrice = Shopify.formatMoney(
      selectedVariant.price,
      theme.moneyFormat
    );

    let deliveryInfo = "";

    if (window.strings && window.strings.delivery) {
      deliveryInfo = `
        <p class="product-config__delivery-message">
          ${window.strings.delivery}
        </p>
      `;
    }

    const summaryUI = `
      <div class="product-config__summary">
        <h2 class="product-config__summary__title">${title}</h2>
        <p class="product-config__summary__price">${formattedPrice}</p>

       <button id="product-config__add-to-cart-button" class="product-config__summary__add-to-bag button">Add to Bag</button>
      ${deliveryInfo}


        <button
          id="product-config__share-button"
          class="product-config__summary__share">
          <span>Share</span>
          <img
            src="https://cdn.shopify.com/s/files/1/0548/9645/9869/files/share_button.svg"
            alt="Share icon"
          />
        </button>
      </div>
    `;

    this.firstLevelWrapper.insertAdjacentHTML(
      "beforeend",
      summaryUI
    );

    const addToBagButton = document.getElementById(
      "product-config__add-to-cart-button"
    );

    const shareButton = document.getElementById(
      "product-config__share-button"
    );

    addToBagButton.addEventListener("click", () => {
      this.CreateCart(lineProperties, selectedVariant);
    });

    shareButton.addEventListener("click", () => {
      this.BuildShareUI();
    });
  }


    async reduce_image_file_size(base64Str, MAX_WIDTH = 450, MAX_HEIGHT = 450) {
    let resized_base64 = await new Promise((resolve) => {
      let img = new Image();
      img.src = base64Str;
      img.onload = () => {
        let canvas = document.createElement("canvas");
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
        canvas.width = width;
        canvas.height = height;
        let ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL()); // this will return base64 image results after resize
      };
    });
    return resized_base64;
  }

  async GetProductSnapshot() {
    const snapshot = await this.api.scene.requestScreenshot({
      format: "png",
      width: 800,
      height: 800,
      keepPosition: false,
      verticalAngle: 90,
      horizontalAngle: 0,
    });

    // return snapshot.dataUrl;

    return this.reduce_image_file_size(snapshot.dataUrl, 800, 800);
  }

  async CreateLineItems() {
    const selectedElementsArray = Object.keys(this.selectedElements);
    const productSnapshot = await this.GetProductSnapshot();
    const lineItems = {
      "Surface color": "",
      Theme: "",
      "Line design and colours": "",
      "End to end lines": "",
      "45 Degree Lines": "",
      "Reverse points": "",
      Text: "",
      "Text - User input": "",
      "Font family": "",
      "Font colour": "",
      _Image: "",
    };
    const mapLinePropertyName = (property) => {
      switch (property) {
        case "surfaceColor":
          return {
            propertyName: "Surface color",
            parentName: "Surface Color",
            level: 1,
          };
        case "themeSelection":
          return {
            propertyName: "Theme",
            parentName: "Theme Category",
            level: 2,
          };
        case "lineDesignAndColorsSelection":
          return {
            propertyName: "Line design and colours",
            parentName: "Line Design & Colours",
            level: 2,
          };
        case "endToEndLines":
          return {
            propertyName: "End to end lines",
            parentName: "End to End points",
            level: 1,
          };
        case "sideBars":
          return {
            propertyName: "45 Degree Lines",
            parentName: "45 Degree Lines",
            level: 1,
          };
        case "reversePoints":
          return {
            propertyName: "Reverse points",
            parentName: "Reverse Point",
            level: 1,
          };
        case "fontAndColour":
          return {
            propertyName: "Font family",
            parentName: "Font and Colour",
            level: 1,
          };
        case "fontColour":
          return {
            propertyName: "Font colour",
            parentName: "Font and Colour",
            level: 1,
          };
        case "text":
          return {
            propertyName: "Text",
            parentName: "Text",
            level: 1,
          };
        case "textSelection":
          return {
            propertyName: "Text - User input",
            parentName: "Text",
            level: 2,
          };
        default:
          return null;
      }
    };

    selectedElementsArray.forEach((key) => {
      const keyProperties = mapLinePropertyName(key);

      if (keyProperties) {
        const { propertyName, parentName, level } = keyProperties;
        const propertyConfiguration = this.GetInnerConfiguration(
          parentName,
          level,
          key
        );

        if (propertyConfiguration) {
          const { selectedChildren, selectedParent } = propertyConfiguration;
          let propertyValue = "";

          if (selectedChildren) {
            const { name } = selectedChildren;
            propertyValue = name;
          } else if (key === "textSelection") {
            propertyValue = this.selectedElements[key];
          }

          if (level > 1 && selectedParent && key !== "textSelection") {
            const {
              parent: { uuid: parentUuid },
              name: childrenName,
            } = selectedChildren;
            const { children } = selectedParent;
            const filteredCategory = children.filter(
              (child) => child.uuid === parentUuid
            );

            if (filteredCategory.length === 1) {
              const { name: parentName, label: parentLabel } =
                filteredCategory[0];
              const selectedParent = parentLabel || parentName;
              propertyValue = `${selectedParent} - ${childrenName}`;
            }
          }

          if (propertyName && propertyValue) {
            lineItems[propertyName] = propertyValue;
          }
        }
      }
    });

    lineItems["_Image"] = productSnapshot;

    return lineItems;
  }

  GetSelectedVariant() {
    if (!this.mainProduct?.variants) return null;
    const surfaceColor = this.GetInnerConfiguration(
      "Surface Color", 1, "surfaceColor"
    );
    const colorName = surfaceColor?.selectedChildren?.name;
    if (!colorName) return null;

    // No hard-coded colour list: match the selected Sayduck colour
    // to Shopify's "LYM / [Colour] / 3 Lines" variant title.
    const selectedVariantTitle = `LYM / ${colorName} / 3 Lines`;
    return this.mainProduct.variants.find(
      (variant) => variant.title.toLowerCase().trim() ===
        selectedVariantTitle.toLowerCase().trim()
    ) || null;
  }

  
    BuildShareUI() {
    const productConfiguratorWrapper = document.getElementById(
      "3d-product-configurator"
    );

    const shareUI = `
      <div id="product-config__share" class="product-config__share">
        <div class="product-config__share__wrapper">

          <button
            id="product-config__share-button-close"
            class="product-config__share__close-button"
          >
            <img
              alt="Close share modal icon"
              src="https://cdn.shopify.com/s/files/1/0548/9645/9869/files/close-button.svg?v=1634677328"
            />
          </button>

          <h2
            class="product-config__share__title"
            style="color: ${window.strings.shareDesignTitleColor};"
          >
            ${window.strings.shareDesignTitle}
          </h2>

          <p class="product-config__share__content">
            ${window.strings.shareDesignContent}
          </p>

          <div class="product-config__share__social-container">
            <span class="product-config__share__social-container__title">
              Share to
            </span>

            <div class="product-config__share__social-container__icons">
              <button id="product-config__share-email-button">
                <img
                  src="https://cdn.shopify.com/s/files/1/0548/9645/9869/files/envelope.svg?v=1635745095"
                  alt="Email icon"
                />
              </button>

              <button id="product-config__share-url-button">
                <img
                  src="https://cdn.shopify.com/s/files/1/0244/0983/3553/files/copy-link.png"
                  alt="Copy link icon"
                />
              </button>
            </div>
          </div>

          <div class="product-config__share__separator"></div>

          <div class="product-config__share__social-container">
            <span class="product-config__share__social-container__title">
              Save Image
            </span>

            <div class="product-config__share__social-container__icons-no-background">
              <button
                id="product-config__save-image-button"
                aria-label="Save design image"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M17 11.4286V15.7619C17 16.3142 16.5523 16.7619 16 16.7619H2C1.44771 16.7619 1 16.3142 1 15.7619V11.4286"
                    stroke="#504F60"
                    stroke-width="1.5"
                  />
                  <path
                    d="M8.25 1V12M8.25 12L4 7.75M8.25 12L12.5 7.75"
                    stroke="#504F60"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>

        </div>
      </div>
    `;

    productConfiguratorWrapper.insertAdjacentHTML(
      "beforeend",
      shareUI
    );

    const shareUIContainer = document.getElementById(
      "product-config__share"
    );

    const shareUICloseButton = document.getElementById(
      "product-config__share-button-close"
    );

    const shareUIUrlButton = document.getElementById(
      "product-config__share-url-button"
    );

    const shareUIEmailButton = document.getElementById(
      "product-config__share-email-button"
    );

    const saveImageButton = document.getElementById(
      "product-config__save-image-button"
    );

    const closeShareModal = () => {
      shareUIContainer.remove();
    };

    const copyShareURL = async () => {
      try {
        await navigator.clipboard.writeText(
          window.location.href
        );

        this.ShowToast("URL Copied");
      } catch (error) {
        console.error("Unable to copy URL:", error);
      }
    };

    const sendEmail = () => {
      const subject = encodeURIComponent(
        "Custom Yoga Mats from Liforme!"
      );

      const body = encodeURIComponent(
        window.location.href
      );

      window.location.href =
        `mailto:?subject=${subject}&body=${body}`;
    };

    const saveImage = async () => {
      try {
        await this.api.scene.takePhoto({
          format: "png",
          keepPosition: false,
          noCrop: false,
        });

        this.ShowToast("Image saved");
      } catch (error) {
        console.error("Unable to save image:", error);
      }
    };

    shareUICloseButton.addEventListener(
      "click",
      closeShareModal
    );

    shareUIUrlButton.addEventListener(
      "click",
      copyShareURL
    );

    shareUIEmailButton.addEventListener(
      "click",
      sendEmail
    );

    saveImageButton.addEventListener(
      "click",
      saveImage
    );
  }

  ShowToast(text) {
    Toastify({
      text,
      duration: 4000,
      close: true,
      gravity: "bottom",
      position: "center",
      stopOnFocus: false,
      style: {
        background: "#ea5c8e",
        color: "white",
        fontFamily:
          '"Proxima Nova W05 Semibold",helvetica,arial,sans-serif',
        textTransform: "uppercase",
        padding: "12px 32px",
        borderRadius: "30px",
      },
      onClick: function () {},
    }).showToast();
  }

  CreateCart(lineProperties, selectedVariant) {
    const redirectToCart = () => {
      const path = window.location.origin + window.routes.root_url;
      const newLocation = `${path}/cart`;

      window.location = newLocation;
    };

    const addToCart = async () => {
      const { id } = selectedVariant;

      const formData = {
        items: [
          {
            id,
            quantity: 1,
            properties: lineProperties,
          },
        ],
      };

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        const cart = await response.json();

        if (cart.items) {
          console.log("Added personalised Yoga Mat to cart");
          redirectToCart();
        } else {
          alert(cart.description || "Unable to add to cart.");
        }
      } catch (error) {
        console.error("Add to cart error:", error);
        alert("Unable to add to cart. Please try again.");
      }
    };

    addToCart();
  }

  UpdateUIElements(label) {
    const nextButtonDOM = document.getElementById(
      "product-config__next-button"
    );
    const headingDOM = document.getElementById(
      "product-config__current-heading"
    );
    const stepDOM = document.getElementById(
      "product-config__current-step"
    );
    const progressBarWrapperDOM = document.getElementById(
      "configurator__progress-bar"
    );
    const progressBarDOM = document.getElementById(
      "configurator__progress-bar__bar"
    );

    const currentIndex = this.configuration.indexOf(this.activeScreen);
    const currentPosition = currentIndex + 1;
    const totalSteps = this.configuration.length;

    headingDOM.innerText = label;
    stepDOM.innerText = `${currentPosition}/${totalSteps}`;

    const progressBarWrapperWidth = progressBarWrapperDOM.offsetWidth;
    const progressBarWidth = progressBarWrapperWidth / totalSteps;
    const progressBarDistance = currentIndex * progressBarWidth;

    const isLastScreen =
      currentIndex === this.configuration.length - 1;

    progressBarDOM.style.width = `${progressBarWidth}px`;

    anime({
      targets: progressBarDOM,
      translateX: progressBarDistance,
      easing: "easeInOutQuad",
      duration: 200,
    });

    this.firstLevelWrapper.innerHTML = "";
    this.secondLevelWrapper.innerHTML = "";

    const backButtonDOM = document.getElementById(
      "product-config__back-button"
    );

    if (currentIndex === 0) {
      anime({
        targets: progressBarDOM,
        easing: "easeInOutQuad",
        borderRadius: "0 5px 5px 0",
        duration: 200,
      });

      anime({
        targets: backButtonDOM,
        easing: "easeInOutQuad",
        opacity: 0,
        duration: 200,
        cursor: "auto",
      });
    } else {
      anime({
        targets: progressBarDOM,
        easing: "easeInOutQuad",
        borderRadius: "5px",
        duration: 200,
      });

      anime({
        targets: backButtonDOM,
        easing: "easeInOutQuad",
        opacity: 1,
        duration: 200,
        cursor: "pointer",
      });
    }

    if (isLastScreen) {
      anime({
        targets: nextButtonDOM,
        easing: "easeInOutQuad",
        opacity: 0,
        duration: 200,
        cursor: "auto",
      });
    } else {
      anime({
        targets: nextButtonDOM,
        easing: "easeInOutQuad",
        opacity: 1,
        duration: 200,
        cursor: "pointer",
      });
    }
  }

  Navigate(direction) {
    const activeScreenPosition = this.configuration.indexOf(
      this.activeScreen
    );

    let newIndexPosition = activeScreenPosition;

    switch (direction) {
      case "back":
        newIndexPosition = activeScreenPosition - 1;
        break;

      case "next":
        newIndexPosition = activeScreenPosition + 1;
        break;

      default:
        return;
    }

    if (
      newIndexPosition < 0 ||
      newIndexPosition >= this.configuration.length
    ) {
      return;
    }

    if (newIndexPosition !== activeScreenPosition) {
      this.activeScreen = this.configuration[newIndexPosition];
      this.BuildActiveScreen();
    }
  }

    BuildConfigurationLevel(configurations, type, level, parentUUID = null) {
    // Skip the number-of-colours selection.
    // Display the 3 Color print combinations directly.
    if (type === "Line Design & Colours" && level === 1) {
      const threeColorGroup = configurations.find(
        (config) => config.name === "3 Color"
      );

      if (threeColorGroup?.children?.length) {
        this.BuildConfigurationLevel(
          threeColorGroup.children,
          "3 Color",
          2,
          threeColorGroup.uuid
        );
      }

      return;
    }

    if (!configurations?.length) return;

    configurations.forEach((config) => {
      const {
        isConfiguration,
        children,
        name,
        uuid,
        isIndependentSwatch,
      } = config;

      if (isConfiguration) {
        this.BuildConfigurationLevel(
          children,
          name,
          level + 1,
          uuid
        );
      }

      this.BuildSwatch(
        config,
        type,
        level,
        parentUUID,
        isIndependentSwatch
      );

      this.AddSwatchFunctionality(config, type, level);
    });

    this.ModifyConfigurationLevel(type);

    const applyDropShadow = (element) => {
      if (!element) return;

      const isFirstLevel =
        element.id === "configurator__swatches__first-level";

      const secondLevelHasContent =
        this.secondLevelWrapper.children.length > 0;

      const firstLevelHasMandalas =
        this.firstLevelWrapper.children[0]?.innerHTML === "Mandalas";

      if (isFirstLevel) {
        element.classList.add(
          secondLevelHasContent && !firstLevelHasMandalas
            ? "drop-shadow-top-level"
            : "drop-shadow-single-level"
        );
      } else {
        element.classList.add("drop-shadow-bottom-level");
      }
    };

    const firstSwatch = document.getElementById(
      `contigurator_swatch_${configurations[0].id}`
    );

    switch (type) {
      case "3 Color":
      case "Surface Color":
      case "Mandalas":
        if (firstSwatch && configurations.length > 5) {
          applyDropShadow(firstSwatch.parentElement);
        }
        break;

      case "Mantra & Affirmations":
      case "Reverse Point":
      case "End to End points":
      case "Text":
        if (firstSwatch && configurations.length > 2) {
          applyDropShadow(firstSwatch.parentElement);
        }
        break;

      case "Theme Category":
        if (firstSwatch) {
          applyDropShadow(firstSwatch.parentElement);
        }
        break;

      case "Font and Colour": {
        const swatches = Array.from(
          document.getElementsByClassName("configurator__swatch")
        );

        const fontSwatches = swatches.filter((swatch) =>
          swatch.classList.contains(
            "configurator__swatches__button-swatch"
          )
        );

        const colourSwatches = swatches.filter((swatch) =>
          swatch.classList.contains("configurator__swatch__icon")
        );

        if (fontSwatches.length > 3) {
          applyDropShadow(fontSwatches[0].parentElement);
        }

        if (colourSwatches.length > 5) {
          applyDropShadow(colourSwatches[0].parentElement);
        }
        break;
      }

      default:
        break;
    }
  }

  ModifyConfigurationLevel(type) {
    if (type === "Theme Category") {
      this.firstLevelWrapper.classList.add(
        "configurator__swatches__level--hidden"
      );
    } else {
      this.firstLevelWrapper.classList.remove(
        "configurator__swatches__level--hidden"
      );
    }
  }

  BuildSwatch(
    configuration,
    type,
    level,
    parentUUID,
    isIndependentSwatch
  ) {
    // Only display child swatches belonging to the selected group.
    if (level > 1 && parentUUID) {
      const parentProperty = this.MapParentProperties(type);
      const parentPropertyValue = this.selectedElements[parentProperty];

      if (parentPropertyValue !== parentUUID) {
        return;
      }
    }

    const typeName =
      type === "Font and Colour" && isIndependentSwatch
        ? "Font Colour"
        : type;

    switch (typeName) {
      case "Theme Category":
      case "Reverse Point":
      case "Text":
      case "Mantra & Affirmations":
      case "Font and Colour":
        this.BuildButtonSwatch(configuration, level, typeName);
        break;


      case "Mandalas":
      case "Line Design & Colours":
      case "3 Color":
      case "45 Degree Lines":
      case "Font Colour":
        this.BuildIconSwatch(configuration, level, typeName);
        break;

      case "Surface Color":
        this.BuildColorSwatch(configuration, level, typeName);
        break;

      case "End to End points":
        this.BuildTextSwatch(configuration, level, typeName);
        break;

      case "Liforme X You":
      case "Free Text":
        this.BuildInputSwatch(configuration, level, typeName);
        break;

      default:
        break;
    }
  }

   AddSwatchFunctionality(configuration, type, level) {
    const { uuid, isConfiguration, name } = configuration;
    const element = document.getElementById(`contigurator_swatch_${uuid}`);

    if (element) {
      const { type: elementType } = element.dataset;
      const currentProperty = this.MapSelectedProperties(type);

      if (elementType === "button") {
        element.addEventListener("click", () => {
          const currentPropertyValue = this.selectedElements[currentProperty];

          if (currentProperty && currentPropertyValue !== uuid) {
            this.selectedElements = {
              ...this.selectedElements,
              [currentProperty]: uuid,
            };

            document.querySelectorAll(
              ".configurator__swatch--active"
            ).forEach((swatch) => {
              if (swatch.dataset.level === String(level)) {
                swatch.classList.remove("configurator__swatch--active");
              }
            });

            if (type === "Text") {
              this.selectedElements.textSelection = "";

              if (element.innerHTML === "Liforme X You") {
                this.selectedElements.fontAndColour = "liformeFont";
              }
            }

            element.classList.add("configurator__swatch--active");

            if (!isConfiguration) {
              this.UpdateVisualizer(this.activeScreen, configuration);
            }

            this.BuildActiveScreen();
            this.SetQueryParameters(currentProperty, uuid);

            setTimeout(() => {
              const firstOption = this.secondLevelWrapper.children[0];

              if (
                firstOption &&
                element.getAttribute("data-level") === "1"
              ) {
                firstOption.click();
              }
            }, 100);
          }
        });
      }

      if (elementType === "input") {
        const currentValue = this.selectedElements.textSelection;
        const currentText =
          type === "Liforme X You"
            ? `LIFORME X ${currentValue}`
            : currentValue;

        const fontConfigurations = this.GetFontConfigurations(
          this.selectedElements.fontAndColour
        );
        const fontColour = this.GetFontColor(
          this.selectedElements.fontColour
        );

        this.UpdateVisualizer(this.activeScreen, configuration);
        this.UpdateTextNode(currentText);
        this.UpdateTextNodeAttributes({
          ...fontConfigurations,
          color: fontColour,
        });

        setTimeout(() => this.ChangeCameraPosition("Text"), 100);

        this.selectedElements = {
          ...this.selectedElements,
          [currentProperty]: uuid,
        };

        this.SetQueryParameters(currentProperty, uuid);

        element.addEventListener("input", (e) => {
          e.preventDefault();

          const text = e.target.value.replace(
            /[^a-zA-Z0-9 \b]/g,
            ""
          );

          const modifiedText = this.GetModifiedText(text);

          this.selectedElements = {
            ...this.selectedElements,
            textSelection: text,
          };

          this.UpdateTextNode(modifiedText);
          this.SetQueryParameters("textSelection", text);
        });
      }

      if (elementType === "preselectedText") {
        element.addEventListener("click", () => {
          const fontConfigurations = this.GetFontConfigurations(
            this.selectedElements.fontAndColour
          );
          const fontColour = this.GetFontColor(
            this.selectedElements.fontColour
          );

          const freeTextConfiguration = this.configuration
            .find((config) => config.name === "Text")
            .children.find((child) => child.name === "Free Text")
            .children[0];

          this.UpdateVisualizer(
            this.activeScreen,
            freeTextConfiguration
          );

          this.UpdateTextNode(name);
          this.UpdateTextNodeAttributes({
            ...fontConfigurations,
            color: fontColour,
          });

          this.selectedElements = {
            ...this.selectedElements,
            [currentProperty]: uuid,
            textSelection: name,
          };

          this.SetQueryParameters(currentProperty, uuid);
          this.BuildActiveScreen();
        });
      }

      if (elementType === "fontColour") {
        element.addEventListener("click", () => {
          this.selectedElements = {
            ...this.selectedElements,
            fontColour: uuid,
          };

          const fontColour = this.GetFontColor(uuid);
          const fontConfigurations = this.GetFontConfigurations(
            this.selectedElements.fontAndColour
          );

          if (fontColour) {
            this.UpdateTextNodeAttributes({
              ...fontConfigurations,
              color: fontColour,
            });

            this.UpdateTextNode(
              this.GetModifiedText(
                this.selectedElements.textSelection
              )
            );
          }

          this.BuildActiveScreen();
          this.SetQueryParameters("fontColour", uuid);
        });
      }

      if (elementType === "fontFamily") {
        element.addEventListener("click", () => {
          this.selectedElements = {
            ...this.selectedElements,
            [currentProperty]: uuid,
          };

          const fontConfigurations = this.GetFontConfigurations(uuid);
          const fontColour = this.GetFontColor(
            this.selectedElements.fontColour
          );

          if (fontConfigurations) {
            this.UpdateTextNodeAttributes({
              ...fontConfigurations,
              color: fontColour,
            });

            this.UpdateTextNode(
              this.GetModifiedText(
                this.selectedElements.textSelection
              )
            );
          }

          this.BuildActiveScreen();
          this.SetQueryParameters(currentProperty, uuid);
        });
      }
    }
  }

    UpdateTextNode(text) {
    const input = document.querySelector(".configurator__swatch__input");

    const currentFont = this.selectedElements.fontAndColour;

    const formattedText =
      currentFont === "liformeFont"
        ? text.toUpperCase()
        : text;

    const blackListedWords = JSON.parse(
      localStorage.getItem("blacklisted-words") || "[]"
    );

    const hasBlackListedWord =
      Array.isArray(blackListedWords) &&
      blackListedWords.some((badWord) =>
        formattedText.toLowerCase().trim().includes(badWord)
      );

    if (hasBlackListedWord) {
      if (input) {
        input.setCustomValidity("Bad word found!");
        input.reportValidity();
      }
      return;
    }

    if (input) {
      input.setCustomValidity("");
    }

    const placeholder = input?.getAttribute("placeholder");

    let maxCharacters;

    switch (placeholder) {
      case "Enter Your Name":
        maxCharacters = 18;
        break;
      case "Type whatever you want":
        maxCharacters = 21;
        break;
      default:
        maxCharacters = 22;
    }

    const characterLimitString = formattedText.substring(
      0,
      maxCharacters
    );

    const textWithSpacing =
      " ".repeat(87) + characterLimitString;

    this.api.scene.updateTextNode(textWithSpacing);
  }

  UpdateTextNodeAttributes(additionalAttributes = {}) {
    const baseAttributes = {
      textAlign: "center",
      maxWidth: 0.6,
      fontSize: 0.04,
    };

    this.api.scene.updateTextNodeAttributes({
      ...baseAttributes,
      ...additionalAttributes,
    });
  }

  UpdateVisualizer(parentConfiguration, childConfiguration) {
    this.api.configurator.setConfigurationValue(
      parentConfiguration,
      childConfiguration
    );
  }

  MapSelectedProperties(type) {
    switch (type) {
      case "Surface Color":
        return "surfaceColor";

      case "End to End points":
        return "endToEndLines";

      case "45 Degree Lines":
        return "sideBars";

      case "Reverse Point":
        return "reversePoints";

      case "Line Design & Colours":
        return "lineDesignAndColors";

      case "3 Color":
        return "lineDesignAndColorsSelection";

      case "Theme Category":
        return "theme";
      case "Mandalas":

        return "themeSelection";

      case "Text":
        return "text";

      case "Liforme X You":
      case "Mantra & Affirmations":
      case "Free Text":
        return "textOptionSelection";

      case "Font and Colour":
        return "fontAndColour";

      case "Font Colour":
        return "fontColour";

      default:
        return "";
    }
  }

  MapParentProperties(type) {
    switch (type) {
      case "Mandalas":
        return "theme";

      case "3 Color":
        return "lineDesignAndColors";

      case "Liforme X You":
      case "Mantra & Affirmations":
      case "Free Text":
        return "text";

      default:
        return "";
    }
  }

    BuildInputSwatch(configuration, level, type) {
    const { uuid } = configuration;

    const getInputConfiguration = () => {
      switch (type) {
        case "Liforme X You":
          return {
            placeholder: "Enter Your Name",
          };

        default:
          return {
            placeholder: "Type whatever you want",
          };
      }
    };

    const { placeholder } = getInputConfiguration();

    let maxCharacters = "";

    switch (placeholder) {
      case "Enter Your Name":
        maxCharacters = "(Max 8 Characters)";
        break;

      default:
        maxCharacters = "(Max 20 Characters)";
    }

    const htmlStructure = `
      <div
        id="contigurator_swatch_${uuid}"
        data-level="${level}"
        data-type="input"
        class="configurator__swatch configurator__swatches__input-swatch"
      >
        <div class="configurator__swatches__input-swatch__wrapper">
          <input
            type="text"
            placeholder="${placeholder}"
value="${this.selectedElements.textSelection || ''}"
            class="configurator__swatch__input"
            maxlength="${maxCharacters.replace(/\D/g, "")}"
          />
          <label>${maxCharacters}</label>
        </div>
      </div>
    `;

    this.AppendSwatchToLevel(htmlStructure, level);
  }

  BuildIconSwatch(configuration, level, type) {
    const { name, label, uuid, isConfiguration } = configuration;

    const currentProperty = this.MapSelectedProperties(type);
    const currentPropertyValue = this.selectedElements[currentProperty];
    const isSwatchActive = currentPropertyValue === uuid;
    const iconLabel = label || name;

    const currentLevel = type === "Font Colour" ? 2 : level;
    const swatchType = type === "Font Colour" ? "fontColour" : "button";

    const getSwatchSizeClass = () => {
      if (currentLevel > 1 && type !== "Mandalas") {
        return "configurator__swatch__icon--sm";
      }

      if (!isConfiguration || type === "Mandalas") {
        return "configurator__swatch__icon--lg";
      }

      return "";
    };

    const swatchSizeClass = getSwatchSizeClass();

    const swatchActiveClass = isSwatchActive
      ? "configurator__swatch--active"
      : "";

    const labelBehaviour = isSwatchActive
      ? "configurator__swatches__label--thin"
      : "configurator__swatches__label--hidden";

    const getSVGUrl = () => {
      switch (type) {
      case "3 Color": {
          switch (name) {
            case "Lunar":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Lunar.svg?v=1792066675";
            case "Peony":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Peony.svg?v=1792066675";
            case "Blue Mist":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Blue_Mist.svg?v=1792066675";
            case "Lemon Sorbet":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Lemon_Sorbet.svg?v=1792066753";
                     };

          return icons[name] || "";
        }

        case "45 Degree Lines": {
          const icons = {
            Straight: [
              "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/straight_side_bars.svg?v=1634694423",
              "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/straight_side_bars_inactive.svg?v=1635221372",
            ],
            Curved: [
              "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/curved_side_bars.svg?v=1634694423",
              "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/curved_side_bars_inactive.svg?v=1635221415",
            ],
            None: [
              "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/no_side_bars.svg?v=1634694423",
              "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/no_side_bars_inactive.svg?v=1635221372",
            ],
          };

          return icons[name]?.[isSwatchActive ? 0 : 1] || "";
        }

        case "Mandalas": {
          const icons = {
            Classic:
              "https://cdn.shopify.com/s/files/1/0244/0983/3553/files/Mandala-Classic.png",
            "Cosmic Moon":
              "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Frame_655.png?v=1701685691",
            "Mindful Garden":
              "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Mandala-Mindful_Garden.png?v=1701277353",
            Paisley:
              "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Mandala-Paisley_7ef8a9b6-76fe-4e7c-ad1e-964550f5cf0e.png?v=1701343946",
            Cube:
              "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Mandala-Cube_480d0e8d-eabb-49fc-9bc7-4a0079c55243.png?v=1701343946",
            "Planet Earth":
              "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Mandala-Planet_Earth_de6e3c9e-8c3c-470f-a093-7dab2255186f.png?v=1701343946",
            Geometric:
              "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Mandala-Geometric_3cfb1377-db27-4182-b1c0-8d6226ec0fbc.png?v=1701343946",
            "Simple Curved":
              "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Simple_Curved_icon_2.png?v=1701343946",
            "Simple Straight":
              "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Mandala-Simple_Straight_3f2ea0f6-08fa-467b-815d-8f91549fb074.png?v=1701343946",
            Love:
              "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Group_165_16886a85-1d52-44c6-9ef6-2292ef4d2571.png?v=1701343946",
          };

          return icons[name] || "";
        }

         // Font color
        case "Font Colour": {
          switch (name) {
            case "Baby Blue":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Baby_Blue.svg?v=1792147908";
            case "Lime":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Lime.svg?v=1792147908";
            case "Pastel Orange":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Pastel_Orange.svg?v=1792147908";
            case "Vanilla":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Vanilla_cc310a44-49c8-4748-b1ae-a59153ef015d.svg?v=1792147908";
            case "Citrus":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Citrus_c5173f23-4c89-4552-894f-cf06701e51f5.svg?v=1792147908";
             case "Lavender":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Lavendar.svg?v=1792147908";
            case "Peony":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Peony_41d45e43-9d2d-4042-8642-d0a5659ed63c.svg?v=1792147908";
           
          };

        return "";
        }

        default:
          return "";
      }
    };

    const currentIcon = getSVGUrl();

    const htmlStructure = `
      <button
        id="contigurator_swatch_${uuid}"
        data-level="${currentLevel}"
        data-type="${swatchType}"
        class="configurator__swatch configurator__swatch__icon ${swatchSizeClass} ${swatchActiveClass}"
      >
        <div class="configurator__swatch__icon__wrapper">
          <img src="${currentIcon}" alt="${name} icon" />
        </div>
        <label class="configurator__swatches__label ${labelBehaviour}">
          ${iconLabel}
        </label>
      </button>
    `;

    this.AppendSwatchToLevel(htmlStructure, currentLevel);
  }

    BuildButtonSwatch(configuration, level, type) {
    const { name, uuid } = configuration;
    const currentProperty = this.MapSelectedProperties(type);
    const currentPropertyValue = this.selectedElements[currentProperty];
    const swatchActiveClass =
      currentPropertyValue === uuid ? "configurator__swatch--active" : "";
    const getSwatchType = () => {
      switch (type) {
        case "Font and Colour":
          return "fontFamily";

        case "Mantra & Affirmations":
          return "preselectedText";

        default:
          return "button";
      }
    };
    const swatchType = getSwatchType();
    const textType = this.selectedElements.textOptionSelection;

    if (swatchType === "fontFamily") {
      let fontClass = "";
      switch (name) {
        case "Simple":
          fontClass = "simple-font";
          break;
        case "Rounded":
          fontClass = "rounded-font";
          break;
        case "Handwritten":
          fontClass = "handwritten-font";
          break;
      }
      if (textType === "33f5f460-368e-013f-2952-6a4000cd166d") {
        var htmlStructure = "";
        if (uuid === "liformeFont") {
          htmlStructure = `
            <button id="contigurator_swatch_${uuid}" data-level="${level}" data-type=${swatchType} class="configurator__swatch configurator__swatches__button-swatch ${swatchActiveClass}">${name}</button>
            <div class="liforme-font-notification">This text option is only available in Liforme font</div>
          `;
        } else {
          htmlStructure = `
            <button id="contigurator_swatch_${uuid}" data-level="${level}" data-type=${swatchType} class="configurator__swatch configurator__swatches__button-swatch ${fontClass} disabled">${name}</button>
          `;
        }

        this.AppendSwatchToLevel(htmlStructure, level);
      } else {
        const htmlStructure = `
          <button id="contigurator_swatch_${uuid}" data-level="${level}" data-type=${swatchType} class="configurator__swatch configurator__swatches__button-swatch ${fontClass} ${swatchActiveClass}">${name}</button>
        `;

        this.AppendSwatchToLevel(htmlStructure, level);
      }
    } else {
      const htmlStructure = `
        <button id="contigurator_swatch_${uuid}" data-level="${level}" data-type=${swatchType} class="configurator__swatch configurator__swatches__button-swatch ${swatchActiveClass}">${name}</button>
      `;

      this.AppendSwatchToLevel(htmlStructure, level);
    }
  }

  BuildTextSwatch(configuration, level, type) {
    const { name, uuid, isConfiguration } = configuration;
    const currentProperty = this.MapSelectedProperties(type);
    const currentPropertyValue = this.selectedElements[currentProperty];
    const swatchSizeClass =
      level > 1
        ? "configurator__swatch__icon--sm"
        : !isConfiguration
          ? "configurator__swatch__icon--lg"
          : "";
    const swatchActiveClass =
      currentPropertyValue === uuid ? "configurator__swatch--active" : "";

    const htmlStructure = `
      <button id="contigurator_swatch_${uuid}" data-level="${level}" data-type="button" class="configurator__swatch configurator__swatch__icon configurator__swatch__icon--only-text ${swatchSizeClass} ${swatchActiveClass}">
        <div class="configurator__swatch__icon__wrapper">
          <div><span>${name}</span></div>
        </div>
      </button>
    `;

    this.AppendSwatchToLevel(htmlStructure, level);
  }

  BuildColorSwatch(configuration, level, type) {
    const { name, uuid, isConfiguration } = configuration;

    const colorClasses = {
      "Blue": "blue",
      "Dusk Blue": "dusk",
      "Olive": "olive",
      "Red": "red",
      "Black": "black",
      "Terracotta": "terracotta",
      "Deep Forest Green": "forest",
      "White": "white",
      "Maroon": "maroon",
      "Golden Sand": "sand",
      "Pink": "pink",
      "Grey": "grey",
      "Aqua Teal": "aqua",
      "Orange": "orange",
      "Purple": "purple",
      "Yellow": "yellow"
    };

    const currentColorClass = colorClasses[name] || "";
    const currentProperty = this.MapSelectedProperties(type);
    const currentPropertyValue = this.selectedElements[currentProperty];
    const swatchActiveClass =
      currentPropertyValue === uuid ? "configurator__swatch--active" : "";
    const swatchSizeClass =
      level > 1
        ? "configurator__swatch__icon--sm"
        : !isConfiguration
          ? "configurator__swatch__icon--lg"
          : "";

    const htmlStructure = `
      <button id="contigurator_swatch_${uuid}" data-level="${level}" data-type="button" class="configurator__swatch configurator__swatch__icon configurator__swatch__icon--hide-inactive ${swatchSizeClass} ${swatchActiveClass}">
        <div class="configurator__swatch__icon__wrapper">
          <svg class="configurator__swatches__color-swatch__color configurator__swatches__color-swatch--${currentColorClass}" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <circle cx="50" cy="50" r="50"/>
          </svg>
        </div>
        <label class="configurator__swatches__label">${name}</label>
      </button>
    `;

    this.AppendSwatchToLevel(htmlStructure, level);
  }

  AppendSwatchToLevel(swatch, level) {
    let levelWrapper = null;

    if (level === 1) {
      levelWrapper = this.firstLevelWrapper;
    } else if (level === 2) {
      levelWrapper = this.secondLevelWrapper;
    }

    if (levelWrapper) {
      levelWrapper.insertAdjacentHTML("beforeend", swatch);
    }
  }

  GetFontConfigurations(uuid) {
    switch (uuid) {
      case "liformeFont":
        return {
          font: "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/The_Liforme_Typeface.otf?v=1635376453",
          fontSize: 0.05,
          anchorY: -0.025,
          letterSpacing: -0.05,
        };

      case "simpleFont":
        return {
          font: "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/Urbane_Rouned_-_Medium.otf?v=1635376453",
          fontSize: 0.035,
          anchorY: 0.003,
        };

      case "roundedFont":
        return {
          font: "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/Chennai.otf?v=1635376453",
          fontSize: 0.04,
          anchorY: 0.008,
          letterSpacing: 0.01,
        };

      case "handwrittenFont":
        return {
          font: "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/Mister_Brown.otf?v=1635376453",
          fontSize: 0.055,
          anchorY: -0.01,
        };
    }
  }
GetFontColor(uuid) {
  const colors = {
    babyBlue: "#76CAE6",
    lime: "#82F346",
    pastelOrange: "#F0C75E",
    vanilla: "#F0E8CD",
    citrus: "#EBD064",
    lavender: "#B7A1D4",
    peony: "#F3ACD1",
  };

  return colors[uuid] || "";
}

  GetModifiedText(text) {
    const currentSelectedText = this.selectedElements.textOptionSelection;

    if (
      currentSelectedText ===
      "33f5f460-368e-013f-2952-6a4000cd166d"
    ) {
      return `LIFORME X ${text}`;
    }

    return text;
  }
}

// Initialise configurator
const Init = () => {
  const sayduckInit = (e) => {
    const sayduckAPI = e.detail.instance;
    const configurator = new ProductConfigurator(sayduckAPI);

    const closeButton = document.getElementById("product-config__close-button");
    const stayButton = document.getElementById("product-config__stay-button");
    const modalWrapper = document.getElementById("product-config__modal");
    const backButton = document.getElementById("product-config__back-button");
    const nextButton = document.getElementById("product-config__next-button");

    const handleCloseButton = () => {
      const isVisible = modalWrapper.classList.contains(
        "configurator__close-modal--visible"
      );

      if (!isVisible) {
        modalWrapper.classList.add("configurator__close-modal--visible");
        return;
      }

      modalWrapper.classList.remove("configurator__close-modal--visible");
    };

    const closeModal = (e) => {
      const target = e.target;
      const closestModal = target.closest(".configurator__modal");
      const closestTrigger = target.closest(".configurator__modal__trigger");

      if (!closestModal && !closestTrigger) {
        modalWrapper.classList.remove("configurator__close-modal--visible");
      }
    };

    const handleNavigation = (direction) => {
      configurator.Navigate(direction);
    };

    const dropShadowClasses = [
      "drop-shadow-top-level",
      "drop-shadow-single-level",
      "drop-shadow-bottom-level",
    ];

    const removeDropShadow = () => {
      dropShadowClasses.forEach((shadowClass) => {
        document
          .getElementById("configurator__swatches__first-level")
          .classList.remove(shadowClass);

        document
          .getElementById("configurator__swatches__second-level")
          .classList.remove(shadowClass);
      });
    };

    // Initialise the configurator
    configurator.InitializeConfigurator();

    // Register events
    document.addEventListener("click", closeModal);

    closeButton.addEventListener("click", handleCloseButton);
    stayButton.addEventListener("click", handleCloseButton);

    backButton.addEventListener("click", () => handleNavigation("back"));
    nextButton.addEventListener("click", () => handleNavigation("next"));

    backButton.addEventListener("mousedown", removeDropShadow);
    nextButton.addEventListener("mousedown", removeDropShadow);
  };

  window.addEventListener("sayduck.api-ready", sayduckInit);
};

// Global initialisation
document.body.classList.add("configurator--hide-scroll");
document.addEventListener("DOMContentLoaded", Init);

// Set viewport height
const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty("--app-height", `${window.innerHeight}px`);
};

window.addEventListener("resize", appHeight);
appHeight();

// Position Sayduck AR and screenshot buttons
function PositionSayduckButtons() {
  const viewer = document.querySelector("sayduck-viewer");
  const root = viewer?.shadowRoot;

  if (!root) return false;

  const priceBadge = document.getElementById("configurator-live-price");

  const offset = priceBadge
    ? priceBadge.offsetTop + priceBadge.offsetHeight - 7
    : 25;

  const arButton = root.querySelector('button[class*="_arButton_"]');

  const screenshotContainer = root.querySelector(
    'button[class*="_menuButton_"]'
  )?.parentElement;

  if (arButton) {
    arButton.style.transform = `translateY(${offset}px)`;
  }

  if (screenshotContainer) {
    screenshotContainer.style.transform = `translateY(${offset}px)`;
  }

  return !!(arButton && screenshotContainer);
}

// Wait for Sayduck controls to load
function InitialiseSayduckButtonPosition() {
  const viewer = document.querySelector("sayduck-viewer");
  const root = viewer?.shadowRoot;

  if (!root) {
    setTimeout(InitialiseSayduckButtonPosition, 200);
    return;
  }

  PositionSayduckButtons();

  const observer = new MutationObserver(() => {
    PositionSayduckButtons();
  });

  observer.observe(root, {
    childList: true,
    subtree: true,
  });

  window.addEventListener("resize", PositionSayduckButtons);
}

InitialiseSayduckButtonPosition();